// @vendors
import React from 'react'
import { useTranslation } from 'react-i18next';

// @components
import Modal from '../Modal';

// @assets
import emoji from "../../../assets/icons/icon_close.svg"

const ModalDelete: React.FC<{
    open: boolean;
    close: () => void;
    submit: () => void;
    title: string;
}> = ({ open, close, submit, title }) => {
    const { t } = useTranslation();

    return (
        <Modal
            isOpen={open}
            onClose={close}
            title=""
            hasButtonClose={false}
        >
            <div className="min-h-[200px] max-w-[400px] flex flex-col items-center gap-[20px]">
                <img
                    src={emoji}
                    alt="success operation"
                    className="mx-auto mb-2"
                    style={{ width: '100px', height: '100px' }}
                />
                <div className="flex flex-col gap-1 mb-2 items-center">
                    <p className="flex text-center">{title}</p>
                </div>

                <div className="flex items-center justify-evenly w-full">
                    <button
                        onClick={close}
                        className="bg-[#525252] text-white px-4 py-2 rounded-lg"
                    >
                        {t("professional.cancelButton")}
                    </button>
                    <button
                        onClick={submit}
                        className="bg-[#F97068] text-white px-4 py-2 rounded-lg"
                    >
                        {t("professional.acceptButton")}
                    </button>
                </div>
            </div>
        </Modal>
    )
}

export default ModalDelete